export default {
  DORMAKABA: 'DORMAKABA',
  ELEVATOR_INTEGRATIONS_APPARTMENT_CALL: 'ELEVATOR_INTEGRATIONS_APPARTMENT_CALL',
  GUEST_ACCESS: 'GUEST_ACCESS',
  HEG_MAINTENANCE: 'HEG_MAINTENANCE',
  ORY_REGISTRATION: 'ORY_REGISTRATION',
  SITE_BLE: 'SITE_BLE',
  USER_BLE_CREDENTIAL: 'USER_BLE_CREDENTIAL',
};
